import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../store/rootReducer';

/**
 * Null-rendering, app-level guard for fire-and-survive bulk operations. While any bulk op is
 * pending it registers a `beforeunload` handler so closing the tab / leaving the app mid-run
 * prompts the user. In-SPA navigation is unaffected — the op lives at the store level. Mount once,
 * beside the global ToastContainer, so the toast + this guard cover the whole app.
 */
const BulkOperationsManager: React.FC = () => {
    const pendingCount = useSelector((state: RootState) => state.bulkOperations.pending.length);

    useEffect(() => {
        if (pendingCount === 0) return;
        const handler = (e: BeforeUnloadEvent) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, [pendingCount]);

    return null;
};

export default BulkOperationsManager;
